import { createContext } from 'react';
import { AppElementContextType } from './types';

export const AppElementContext = createContext<AppElementContextType>(
  {} as unknown as AppElementContextType,
);
